<template>
  <div class="">
    <!-- <transition name="slide" mode="out-in"> -->
    <loading pic="loading" v-if="loadingState" key="1" />

    <div v-else class="client__wrapper" key="2">
      <div class="clients__manipulate">
        <div class="clients__actions">
          <button
            type="submit"
            @click="newAttendance()"
            class="action_btn client__add"
          >
            <svg
              fill="var(--purple)"
              width="50px"
              height="50px"
              viewBox="0 0 1106.000000 1280.000000"
              preserveAspectRatio="xMidYMid meet"
            >
              <g
                transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
                fill="var(--purple)"
                stroke="none"
              >
                <path
                  d="M1975 12688 c-61 -121 -60 -116 -39 -245 9 -57 0 -87 -41 -132 -33
            -36 -38 -38 -78 -34 -56 7 -133 -31 -178 -87 -18 -22 -38 -40 -45 -40 -31 0
            -55 -36 -64 -98 -7 -48 -16 -71 -39 -98 -17 -19 -33 -44 -35 -57 -2 -12 -9
            -49 -16 -82 -7 -33 -15 -98 -19 -145 -6 -59 -16 -103 -35 -145 -16 -33 -46
            -118 -67 -190 -91 -298 -117 -364 -242 -610 -67 -133 -107 -205 -170 -305 -33
            -52 -71 -115 -85 -140 -14 -25 -35 -61 -46 -80 -12 -19 -27 -46 -33 -60 -6
            -14 -23 -50 -37 -79 -14 -30 -26 -60 -26 -67 0 -6 -6 -17 -13 -23 -8 -6 -20
            -30 -27 -53 -18 -58 -26 -66 -69 -74 -20 -4 -48 -13 -63 -20 -15 -8 -37 -14
            -50 -14 -27 -1 -122 -53 -172 -95 -47 -39 -63 -86 -76 -215 -6 -58 -17 -132
            -24 -165 -8 -33 -19 -87 -26 -120 -33 -158 -93 -344 -125 -385 -21 -27 -35
            -120 -35 -229 0 -109 3 -122 60 -271 12 -30 24 -64 27 -74 15 -48 80 -168 131
            -241 66 -94 187 -239 321 -385 114 -123 238 -264 266 -301 23 -30 117 -144
            144 -174 10 -11 45 -52 77 -90 33 -39 69 -81 81 -95 12 -14 50 -61 85 -105 83
            -106 142 -176 204 -244 27 -31 84 -101 124 -156 122 -164 230 -293 349 -415
            165 -168 179 -186 197 -266 8 -38 19 -85 25 -104 5 -19 16 -206 24 -415 27
            -700 36 -800 105 -1120 11 -55 25 -122 30 -150 5 -27 16 -77 25 -110 27 -99
            45 -176 60 -260 7 -44 18 -100 24 -125 6 -25 10 -70 11 -100 0 -30 7 -104 16
            -165 13 -87 15 -158 11 -345 -7 -275 -32 -677 -47 -737 -8 -35 -7 -51 10 -94
            24 -60 75 -115 122 -131 51 -17 84 -44 98 -80 6 -18 16 -41 21 -51 5 -9 22
            -50 38 -90 16 -39 67 -146 114 -237 47 -91 99 -203 117 -250 18 -47 38 -98 45
            -115 39 -98 80 -230 111 -360 13 -55 28 -113 34 -130 6 -16 15 -109 21 -205 9
            -162 29 -280 47 -280 4 0 13 -13 20 -30 8 -16 19 -30 25 -30 6 0 19 -8 30 -18
            17 -15 48 -17 286 -19 146 -1 287 -6 314 -11 29 -6 65 -6 92 0 49 11 170 8
            516 -12 204 -11 229 -11 257 4 17 9 40 16 52 16 24 0 60 53 60 91 0 54 -30
            125 -72 172 -24 26 -49 47 -56 47 -7 0 -34 16 -59 35 -25 19 -50 35 -55 35 -5
            0 -16 7 -24 15 -9 8 -24 15 -33 15 -10 0 -24 7 -31 15 -7 8 -19 15 -27 15 -7
            0 -24 7 -38 16 -19 12 -28 13 -46 4 -14 -8 -39 -10 -68 -6 -62 10 -69 9 -123
            -4 -42 -10 -52 -9 -101 14 -30 14 -58 30 -62 35 -3 6 -16 11 -28 11 -12 1 -40
            12 -62 25 -22 14 -51 30 -64 35 -26 12 -82 65 -94 90 -4 8 -23 40 -42 70 -63
            102 -92 174 -120 300 -9 41 -21 89 -26 105 -6 17 -19 75 -29 130 -11 55 -25
            123 -30 150 -11 57 -67 433 -81 545 -5 41 -6 89 -3 107 3 17 -1 60 -9 95 -10
            40 -18 141 -22 273 -5 143 -12 225 -22 257 -12 37 -13 54 -4 79 21 60 10 115
            -29 145 -12 10 -13 19 0 65 10 38 15 118 16 274 2 370 11 495 46 610 16 55 34
            116 38 135 4 19 13 56 19 83 6 26 16 68 22 95 14 63 28 353 29 590 0 107 4
            202 10 212 7 13 27 20 72 25 35 4 72 12 83 19 11 6 103 16 205 22 282 18 438
            39 517 69 37 15 93 36 123 48 30 12 102 47 161 79 73 40 130 63 180 73 41 9
            97 26 125 39 29 13 67 27 85 31 62 12 172 66 269 133 65 45 117 94 244 235 38
            43 75 77 83 77 7 0 13 4 13 8 0 11 56 37 99 47 51 11 111 57 192 147 80 89
            163 174 247 252 66 61 142 149 142 165 0 6 6 22 14 34 13 19 54 159 70 238 3
            15 14 30 23 34 10 4 149 13 308 20 353 17 361 18 740 118 94 25 208 54 255 66
            116 29 205 56 270 80 55 21 93 27 223 35 50 3 80 12 113 31 25 15 125 53 222
            85 261 87 428 149 532 197 30 14 98 45 150 68 110 49 457 220 474 233 6 5 55
            33 108 61 94 50 103 52 265 76 239 36 300 56 408 133 28 20 92 58 144 84 149
            77 208 117 222 150 9 23 10 31 0 37 -16 11 1 23 62 46 59 22 80 51 76 103 -2
            28 3 47 19 67 22 28 29 79 13 104 -5 7 -29 16 -55 18 -43 5 -46 7 -46 35 0 57
            -14 68 -88 68 -37 0 -83 -5 -102 -11 -61 -18 -183 -49 -184 -47 -23 67 -74 87
            -117 45 -13 -13 -41 -31 -61 -40 -20 -10 -40 -22 -43 -27 -3 -6 -15 -10 -25
            -10 -11 0 -35 -9 -55 -20 -19 -11 -56 -25 -81 -31 -53 -14 -92 -48 -188 -166
            -65 -79 -143 -143 -176 -143 -8 0 -74 -23 -145 -51 -72 -28 -148 -56 -171 -64
            -22 -7 -74 -27 -115 -45 -149 -64 -388 -135 -574 -170 -55 -10 -138 -28 -185
            -40 -47 -12 -101 -25 -120 -29 -49 -11 -123 -37 -189 -67 -65 -29 -67 -30
            -146 -74 -134 -74 -142 -77 -335 -99 -184 -22 -274 -37 -505 -86 -66 -13 -136
            -25 -155 -25 -34 0 -176 26 -191 36 -4 2 -54 13 -111 23 -57 11 -159 33 -228
            50 -69 16 -156 34 -195 39 -96 14 -125 26 -125 54 0 29 28 104 57 150 13 21
            23 44 23 51 0 7 4 17 8 23 5 5 16 29 25 54 11 27 49 80 97 134 44 49 80 92 80
            97 0 5 24 22 53 39 51 29 54 30 200 30 217 0 247 18 247 146 0 51 6 85 21 119
            17 38 19 52 10 72 -8 18 -8 30 0 45 10 19 9 47 -5 108 -5 22 -1 28 36 45 30
            14 49 33 62 59 18 36 18 39 1 76 -9 21 -35 58 -57 82 -80 87 -85 104 -92 283
            -6 182 -19 312 -36 369 -8 25 -34 62 -74 102 -61 61 -97 84 -136 84 -10 0 -41
            14 -68 30 -53 33 -137 60 -190 60 -19 0 -49 7 -68 16 -29 14 -45 15 -110 5
            -41 -6 -115 -11 -164 -11 -106 0 -172 -13 -254 -50 -73 -32 -238 -147 -284
            -196 -34 -37 -72 -104 -72 -126 0 -7 -11 -40 -24 -73 -30 -77 -43 -120 -51
            -170 -9 -59 -34 -172 -53 -238 -13 -46 -23 -62 -49 -78 -18 -11 -33 -24 -33
            -29 0 -4 -25 -19 -55 -34 -30 -14 -55 -29 -55 -33 0 -13 -86 -63 -107 -63 -11
            0 -26 6 -32 14 -7 8 -26 21 -44 30 -18 9 -39 20 -47 25 -8 5 -26 13 -40 19
            -14 6 -117 56 -230 111 l-205 101 -145 130 c-80 72 -165 151 -190 177 -47 49
            -196 177 -265 228 -156 115 -302 263 -369 375 -45 75 -50 82 -89 137 -20 29
            -55 72 -78 95 -23 24 -47 51 -54 61 -34 48 -296 305 -400 392 -38 32 -92 84
            -118 114 -27 31 -77 83 -110 116 -63 60 -99 104 -228 273 -74 99 -143 207
            -165 257 -7 17 -19 66 -28 110 -9 44 -21 89 -26 100 -5 11 -23 55 -41 98 -30
            75 -31 82 -26 185 3 59 10 141 17 182 14 87 7 211 -15 264 -8 19 -15 57 -15
            84 0 34 -6 57 -20 75 -11 14 -26 38 -33 54 -6 16 -33 47 -58 71 -40 36 -52 42
            -92 42 l-45 0 -57 -112z m331 -1815 c43 -54 84 -105 89 -114 9 -15 88 -130
            187 -272 18 -27 68 -96 111 -153 42 -58 81 -113 86 -122 5 -9 37 -51 70 -92
            34 -41 96 -119 139 -174 42 -54 116 -138 164 -187 87 -88 138 -156 138 -183 0
            -8 23 -36 51 -63 28 -26 82 -88 119 -138 93 -123 225 -282 419 -504 104 -120
            307 -320 426 -419 120 -101 195 -170 225 -209 14 -17 48 -60 75 -95 l50 -63
            -1 -125 c-1 -105 -5 -131 -22 -165 -12 -22 -26 -71 -32 -110 -6 -38 -18 -82
            -26 -97 -10 -18 -13 -40 -9 -60 4 -22 0 -48 -13 -79 -17 -38 -28 -49 -64 -63
            -89 -36 -138 -93 -173 -204 -13 -40 -28 -62 -63 -90 -25 -20 -77 -69 -116
            -107 -44 -43 -92 -80 -124 -95 -48 -21 -56 -23 -85 -11 -18 7 -52 18 -77 25
            -25 6 -59 20 -75 31 -29 20 -214 113 -345 173 -36 17 -114 40 -174 51 -60 12
            -112 24 -117 27 -8 5 -97 18 -224 33 -33 4 -70 12 -82 19 -12 7 -54 12 -93 12
            -51 0 -81 5 -108 19 -20 11 -62 32 -92 47 -30 15 -66 35 -79 45 -13 11 -28 19
            -33 19 -5 0 -40 26 -77 58 -37 31 -101 85 -142 119 -41 33 -96 84 -124 112
            -110 111 -387 364 -500 456 -109 88 -196 167 -265 239 -14 15 -38 40 -55 57
            -26 27 -30 40 -33 101 -4 63 -2 72 20 96 28 31 88 124 88 138 0 5 27 47 59 94
            68 97 162 261 175 305 13 42 19 266 9 306 -9 33 -7 43 81 457 14 62 29 127 34
            145 6 18 15 73 22 122 7 50 18 122 25 160 7 39 16 104 20 145 3 41 13 98 20
            125 8 28 19 81 25 119 19 117 74 194 132 182 43 -9 184 11 230 33 24 10 46 20
            49 20 3 1 41 -43 85 -96z"
                />
              </g>
            </svg>
            <p>Nova prisustva</p>
          </button>

          <Period
            @dates="startPeriod"
            @filter-period="filterItems"
            :isGrid="true"
          />
        </div>

        <search-bar
          :searchStr="search"
          :pageSizeNr="pageSize"
          :searchType="'traži (dan, mjesec, godina)'"
          @changed="setPageSize"
          @typed="searchItems"
        />

        <div class="">
          <div class="days__list attend__heading">
            <span>Datum</span>
            <span>Prisustvovale</span>
            <span>Napomena</span>
          </div>
          <div
            v-for="attendance in pageOfItems"
            :key="attendance._id"
            @click="selectAttendance(attendance)"
            class="clients__list attend__list"
          >
            <p class="client__item">
              {{ attendance.attend_date | formatDate }}
            </p>
            <p class="client__item attend__check">
              {{ mapAttendances(attendance) }}
            </p>
            <p class="client__item">{{ attendance.notes }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->

    <jw-pagination
      :items="filteredClients"
      @changePage="onChangePage"
      :initialPage="initialPage"
      :pageSize="pageSize"
      :labels="customLabels"
      :styles="customStyles"
      class="pagine"
    >
    </jw-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/components/utils/Loading.vue';
import { customLabels, customStyles } from '@/components/utils/pageNav.js';
import SearchBar from '@/components/utils/SearchBar.vue';
import Period from '@/components/utils/Period.vue';
import navigation from '@/mixins/navigation';
import navigationSearch from '@/mixins/navigationSearch';
import searchClients from '@/mixins/searchClients';
import dayjs from 'dayjs';
import sr from 'dayjs/locale/sr';

dayjs.locale(sr);

export default {
  name: 'Attendances',

  components: {
    Loading,
    SearchBar,
    Period,
  },

  mixins: [navigation, navigationSearch, searchClients],

  data() {
    return {
      customLabels,
      customStyles,
    };
  },

  computed: {
    ...mapGetters([
      'getAllAttendances',
      'getClientsPage',
      'getClientsPageSize',
      'loadingState',
    ]),
  },

  methods: {
    ...mapActions([
      'fetchAttendances',
      'fetchAttendance',
      'fetchClientsPage',
      'fetchClientsPageSize',
      'attendanceClear',
      'setLoadingState',
    ]),

    async newAttendance() {
      this.setLoadingState(true);
      this.$router.push('/attendance');
      await this.attendanceClear();
    },

    async selectAttendance(attendance) {
      this.setLoadingState(true);
      await this.fetchAttendance(attendance);
      this.setPageNr();
      this.$router.push('/attendance');
    },

    mapAttendances(attendance) {
      return attendance.members.reduce((a, { present }) => a + present, 0);
    },

    async searchItems(val = '') {
      await this.initItems();
      let mu = this.getAllAttendances.filter((post) => {
        return (
          this.$options.filters
            .formatDate(post.attend_date)
            .toLowerCase()
            .includes(val.toLowerCase()) ||
          post.notes.includes(val.toLowerCase())
        );
      });
      this.filteredClients = mu;
    },

    startPeriod(dateFrom, dateTill) {
      this.filterItems(dateFrom, dateTill);
    },

    filterItems(dateFrom, dateTill) {
      this.dateFrom = dateFrom;
      this.dateTill = dateTill;
      let mu = this.getAllAttendances.filter(
        (year) =>
          dayjs(year.attend_date).format('YYYY-MM-DD') >=
            dayjs(dateFrom).format('YYYY-MM-DD') &&
          dayjs(year.attend_date).format('YYYY-MM-DD') <=
            dayjs(dateTill).format('YYYY-MM-DD')
      );
      this.filteredClients = mu;
    },

    async initItems() {
      if (!this.getAllAttendances.length) await this.fetchAttendances();
      this.filteredClients = this.getAllAttendances;
      this.startPeriod(this.dateFrom, this.dateTill);
      if (this.getClientsPage !== 1) this.initialPage = this.getClientsPage;
      if (this.getClientsPageSize !== 10)
        this.pageSize = this.getClientsPageSize;
    },
  },

  filters: {
    formatDate: function (value) {
      if (value) {
        return dayjs(String(value)).format('dddd, DD. MMM YYYY');
      }
    },
  },

  async mounted() {
    await this.initItems();
    this.setLoadingState(false);
  },
};
</script>

<style>
.attend__check {
  text-align: center;
}
</style>
